import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IDeptCdState, IInquiryCndsState, IUserListItemState, IUserItemState, IUserStCdState, IUsr0104MState } from '../../models/usr/usr0104m_model';
  
const initialState: IUsr0104MState = {
    userDatas: [],          // 사용자목록(조회결과)
    deptCdList: [],         // 부서코드 
    userList: [],           // 사용자목록(검색)
    userStCdList: [],       // 사용자상태코드

    inquiryCnds: {
        empNo    : '',   // 직원번호
        deptCd   : '',   // 부서코드 
        baseYy   : commonDate.maskDate(commonDate.getToday(), 'YYYY'),   // 기준년월 
    },

    pageSize : 20,          // 페이징사이즈
    current  : 0,           // 현재페이지
}

export const usr0104m_Slice = createSlice({
    name: "usr0104m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , deptCdList: state.deptCdList
                                   , userList : state.userList
                                   , userStCdList : state.userStCdList});
        },
        setUserDatas: (state, action:PayloadAction<IUserListItemState[]>) => {
            state.userDatas = action.payload;
        },
        setUserItem: (state, action:PayloadAction<IUserListItemState>) => {
            const tmpArr:IUserListItemState[] = state.userDatas.map((item) => {
                return item.empNo === action.payload.empNo ? { ...item, ...action.payload } : item;
            });

            return {
                ...state,
                userDatas : tmpArr
            }
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
        setUserStCdList: (state, action:PayloadAction<IUserStCdState[]>) => {
            state.userStCdList = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0104m_Slice.reducer;
export const Usr0104mAction  = usr0104m_Slice.actions;
export const Usr0104mReducer = usr0104m_Slice.reducer;